module.exports = __webpack_public_path__ + "static/media/OKXWalletIcon.7d6214ee.svg";